// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "colorPrimary-3lsnj";
export { _1 as "__esModule", _2 as "colorPrimary" }
export default { "__esModule": _1, "colorPrimary": _2 }
